import HttpService from './http.service';

class OrderService {
  getOrders(params) {
    return HttpService.get('orders', {
      params,
    })
      .then((res) => res.data);
  }

  getOrderLinePrice(params) {
    return HttpService.get('orders/order_line_price', {
      params,
    })
      .then((res) => res.data);
  }

  sendOrder(orderId, params) {
    return HttpService.get(`orders/send_order/${orderId}`, {
      params,
    })
      .then((res) => res.data);
  }

  getStatuses() {
    return HttpService.get('orders/statuses')
      .then((res) => res.data);
  }

  getOrderPdf(id) {
    return HttpService.get(`orders/pdf/${id}`)
      .then((res) => res.data);
  }

  getCountries(countries) {
    return HttpService.get('orders/countries', countries)
      .then((res) => res.data);
  }

  getOrderLineStatuses() {
    return HttpService.get('orders/lines/statuses')
      .then((res) => res.data);
  }

  getUnitTypes() {
    return HttpService.get('orders/unit_types')
      .then((res) => res.data);
  }

  generateInvoice(id) {
    return HttpService.get(`orders/${id}/generate_invoice`)
      .then((res) => res.data);
  }

  getTransactions(params) {
    return HttpService.get('orders/transactions', {
      params,
    })
      .then((res) => res.data);
  }

  getOrder(id) {
    return HttpService.get(`orders/${id}`)
      .then((res) => res.data);
  }

  createOrder(order) {
    return HttpService.post('orders', order)
      .then((res) => res.data);
  }

  updateOrder(order) {
    return HttpService.patch(`orders/${order.id}`, order)
      .then((res) => res.data);
  }

  deleteOrder(order) {
    return HttpService.delete(`orders/${order.id}`)
      .then((res) => res.data);
  }
}

export default new OrderService();
